import React from "react";

class TruckTrac extends React.Component {
  render() {
    return (
      <section id="trucktrac" className="theme-bg-trucktrac screenshots">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="section-title">
                <h2 className="text-black">TruckTrac</h2>
                <p className="text-black">(hired)</p>
                <img
                  src="https://cdn.johnbernazzani.com/black-line.svg"
                  alt="title-line"
                  className="img-fluid title-line"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <img
                src="https://cdn.johnbernazzani.com/trucktrac_computers.png"
                className="img-fluid"
                alt="1"
              />
            </div>
          </div>
          <div className="row m-0">
            <div className="col-12 text-center app-description">
              <h1>
                <i className="fa fa-desktop" /> + <i className="fa fa-mobile" />
              </h1>
              <p>
                A mobile and web app built to augment industrial trucking
                companies' workflows. Features allow for digital job tickets,
                flexible custom form creation, photo sharing, digital signature
                collection, time logging, detailed truck route location
                tracking, and push notification alerts.
              </p>
              <a
                href="https://rarepetro.com/trucktrac"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="btn btn-primary">Learn More</button>
              </a>
            </div>
          </div>
          <div className="row crafted-with">
            <div className="col-12 text-center">
              <p className="text-black">Available On</p>
            </div>
          </div>
          <div className="row tech-stack d-flex flex-row justify-content-center">
            <div className="app-store-card d-flex align-items-center">
              <a
                href="https://google.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="https://cdn.johnbernazzani.com/app_store.png" alt="1" />
              </a>
            </div>
            <div className="app-store-card d-flex align-items-center">
              <a
                href="https://google.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="https://cdn.johnbernazzani.com/google_play.png" alt="1" />
              </a>
            </div>
          </div>
          <div className="row crafted-with">
            <div className="col-12 text-center">
              <p className="text-black">Crafted with</p>
            </div>
          </div>
          <div className="row tech-stack d-flex flex-row justify-content-center">
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/ionic.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/angular.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/bootstrap.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/node.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/mongodb.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/aws.png" alt="1" />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default TruckTrac;



// WEBPACK FOOTER //
// ./src/components/trucktrac.js